export const FEATURE_GROUP_OPTIONS = [
  { label: 'Survey Capabilities', value: 'SURVEY_CAPABILITIES' },
  { label: 'Survey Templates', value: 'SURVEY_TEMPLATES' },
  { label: 'Survey Management', value: 'SURVEY_MANAGEMENT' },
  { label: 'Survey Reporting', value: 'SURVEY_REPORTING' },
  { label: 'Survey Settings', value: 'SURVEY_SETTINGS' },
];

export const FEATURE_TYPE_OPTIONS = [
  { label: 'Boolean', value: 'BOOLEAN' },
  { label: 'Value', value: 'VALUE' },
];

export const METHOD_OPTIONS = [
  { label: 'GET', value: 'GET' },
  { label: 'POST', value: 'POST' },
  { label: 'PUT', value: 'PUT' },
  { label: 'DELETE', value: 'DELETE' },
  { label: 'PATCH', value: 'PATCH' },
];

export const ROLE_ACL_OPTIONS = [
  { label: 'Super Admin', value: 'SUPER_ADMIN' },
  { label: 'Org Admin', value: 'ORG_ADMIN' },
  { label: 'Org App User', value: 'ORG_APP_USER' },
  { label: 'Org Survey User', value: 'ORG_SURVEY_USER' },
  { label: 'Org Owner', value: 'ORG_OWNER' },
];

export const PLAN_TYPE_OPTIONS = [
  // { label: 'Individual Paid', value: 'IP' },
  // { label: 'Individual Free', value: 'IF' },
  { label: 'Organization Paid', value: 'OP' },
  { label: 'Organization Free', value: 'OF' },
  // { label: 'Custom Enterprise', value: 'CE' },
  { label: 'Enterprise Paid', value: 'EP' },
];

export const ENTERPRISE_PLAN_TYPES = ['EP'] as const;
export const ORGANIZATION_PLAN_TYPES = ['OP', 'OF'] as const;

export const ADDRESS_TYPE_OPTIONS = [
  { label: 'Home', value: 'H' },
  { label: 'Office', value: 'O' },
  { label: 'Billing', value: 'B' },
  { label: 'Shipping', value: 'S' },
] as const;

export const ORG_TYPE_FALLBACK_OPTIONS = [
  { label: 'Standalone', value: 'STANDALONE' },
  { label: 'Subsidiary', value: 'SUBSIDIARY' },
  { label: 'Branch', value: 'BRANCH' },
] as const;

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Other', value: 'OTHER' },
] as const;

export const LANGUAGE_OPTIONS = [
  { label: 'English', value: 'en' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Tamil', value: 'ta' },
] as const;

export const TIME_ZONE_OPTIONS = [
  { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
] as const;

export const COUNTRY_OPTIONS = [
  { label: 'India', value: 'INDIA' },
  { label: 'United States', value: 'USA' },
] as const;

export const STATE_OPTIONS = [
  { label: 'Maharashtra', value: 'MAHARASHTRA' },
  { label: 'Tamil Nadu', value: 'TAMIL_NADU' },
] as const;

export const CURRENCY_OPTIONS = [
  { label: 'INR', value: 'INR' },
  { label: 'USD', value: 'USD' },
];
